import { OauthConfig } from "./user";
import { config } from "./config";
export const oauthConfig: OauthConfig = config;

export enum StatusType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info'
}
